import { Phone, PhoneCall, Instagram, Facebook, Music2 } from 'lucide-react';
import { SITE } from '../lib/site';

const SOCIALS = [
  { icon: Facebook, label: 'Facebook', href: SITE.social.facebook },
  { icon: Instagram, label: 'Instagram', href: SITE.social.instagram },
  { icon: Music2, label: 'TikTok', href: SITE.social.tiktok },
].filter((s) => s.href);

export default function CTABand() {
  return (
    <section style={{ background: 'var(--color-yellow)' }}>
      <div className="max-w-screen-xl mx-auto px-5 md:px-8 py-6 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-0">
        {/* Question */}
        <div className="flex items-center justify-center md:justify-start gap-3">
          <PhoneCall size={26} className="text-ink shrink-0" />
          <div>
            <p className="text-[13px] font-extrabold uppercase tracking-wide text-ink">
              Have a Question?
            </p>
            <p className="text-[13px] text-ink/70">We&apos;re here to help!</p>
          </div>
        </div>

        {/* Call us */}
        <div
          className="flex items-center justify-center gap-3 md:border-l md:border-r px-4"
          style={{ borderColor: 'rgba(18,18,18,0.15)' }}
        >
          <Phone size={26} className="text-ink shrink-0" />
          <div>
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-ink/70">
              Call Us
            </p>
            <a href={SITE.phoneHref} className="display text-2xl text-ink hover:opacity-70 transition-opacity">
              {SITE.phone}
            </a>
          </div>
        </div>

        {/* Socials — hidden entirely until at least one profile is configured */}
        <div className={`flex items-center justify-center md:justify-end gap-4 ${SOCIALS.length ? '' : 'hidden'}`}>
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-ink/70">
            Follow Us
          </p>
          <div className="flex items-center gap-2">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={`${SITE.name} on ${s.label}`}
                className="w-8 h-8 rounded-full flex items-center justify-center transition-transform hover:-translate-y-0.5"
                style={{ background: 'var(--color-ink)' }}
              >
                <s.icon size={15} style={{ color: 'var(--color-yellow)' }} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
